import { motion } from 'framer-motion';
import styled from 'styled-components';

import { tokens as sheetTokens } from '@pkg/components/Sheet/tokens';
import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledMedia,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './InfoAction.tokens';

export const StyledInfoAction = styled.button.attrs({ type: 'button' })`
    ${styledReset.button};
    padding: ${tokens.padding}px;
    color: rgb(255, 255, 255, 0.4);
    border-radius: 999px;
    outline: 2px solid transparent !important;
    outline-offset: 2px;
    transition-property: color, outline-color;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &:focus-visible {
        outline-color: ${designColor.brandPurple} !important;
    }

    &:focus,
    &:hover {
        color: rgb(255, 255, 255, 0.8);
    }
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.iconSize}px;
    height: ${tokens.iconSize}px;
`;

export const Tooltip = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    // TODO: This z-index should not be necessary once we eliminate it
    // from <Sheet />... until then, we need to stay one above Sheet.
    z-index: ${sheetTokens.zindex.temp + 1};
    width: max-content;

    // Prevent 'floating-ui > tabindex' outline.
    outline: none;
`;

export const TooltipInterior = styled.div`
    padding: ${tokens.tooltip.padding}px;
    border-radius: ${tokens.tooltip.radius}px;
    background-color: ${designColor.coal};
    box-shadow: 0 2px 4px rgb(0, 0, 0, 0.1);
    outline: 2px solid transparent;
    outline-offset: 2px;
    transition-property: outline-color ${duration.normal}ms ${easing.cubic};

    ${Tooltip}:focus-visible & {
        outline-color: ${designColor.brandPurple};
    }
`;

export const TooltipMessage = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.fontSize}px;
`;
